import React, { useEffect, useState, createContext } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useLocation } from "react-router-dom";
import SearchStringOrIntReq5 from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import AccountingApi from "../../../Classes/API/AccountingApi";
import StayDetailsCard from "./StayDetailsCard";
import AddSessionToStay from "./AddSessionToStay";
import AddExtraToStay from "./AddExtraToStay";
import ExtrasTable from "./ExtrasTable";
import AddExtraSessionToStay from "./AddExtraSessionToStay";
import SessionsTable from "layouts/AccountingSessions/SessionsTable";
import StaySessionsTable from "./StaySessionsTable";
const index = () => {
  let { state } = useLocation();
  const [IsLoaded, setIsLoaded] = useState(false);
  const [Stay, setStay] = useState({});
  const [ShowAddSession, setShowAddSession] = useState(false);
  const [ShowAddExtraSession, setShowAddExtraSession] = useState(false);
  const [ShowAddExtra, setShowAddExtra] = useState(false);
  const [ShowExtrasTable, setShowExtrasTable] = useState(false);
  const [showAccountingSessions, setShowAccountingSessions] = useState(false);
  const [showExtraAccountingSessions, setShowExtraAccountingSessions] = useState(false);
  const GetStayData = async (id) => {
    let req = new SearchStringOrIntReq5();
    req.SearchInt = id;
    let res = await AccountingApi.GetDomesticStayById(req);
    if (res.status == "Success") {
      setStay(res.data);
    }
  };

  useEffect(async () => {
    console.log({ IsLoaded });
    if (!IsLoaded) {
      await GetStayData(state.SearchStay.id);
    }
  }, [IsLoaded]);

  useEffect(() => {
    if (Object.keys(Stay).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [Stay]);

  useEffect(() => {
    if (ShowAddSession || ShowAddExtra) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [ShowAddSession, ShowAddExtra]);

  useEffect(() => {
    if (showAccountingSessions || showExtraAccountingSessions) {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [showAccountingSessions, showExtraAccountingSessions]);

  if (!IsLoaded && Object.keys(Stay).length < 1) {
    return <div>Loading Stay Data...</div>;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {ShowAddSession && (
        <AddSessionToStay
          setIsLoaded={setIsLoaded}
          setShowAddSession={setShowAddSession}
          Stay={Stay}
        />
      )}
      {ShowAddExtra && (
        <AddExtraToStay setIsLoaded={setIsLoaded} setShowAddExtra={setShowAddExtra} Stay={Stay} />
      )}
      {ShowExtrasTable && <ExtrasTable setIsLoaded={setIsLoaded} Stay={Stay} />}
      {ShowAddExtraSession && (
        <AddExtraSessionToStay
          setIsLoaded={setIsLoaded}
          setShowAddSession={setShowAddExtraSession}
          Stay={Stay}
        />
      )}
      <StayDetailsCard
        setShowAddExtraSession={setShowAddExtraSession}
        setShowExtrasTable={setShowExtrasTable}
        ShowExtras={ShowExtrasTable}
        setShowAddExtra={setShowAddExtra}
        setIsLoaded={setIsLoaded}
        Stay={Stay}
        setShowAddSession={setShowAddSession}
        showAccountingSessions={showAccountingSessions}
        setShowAccountingSessions={setShowAccountingSessions}
        showExtraAccountingSessions={showExtraAccountingSessions}
        setShowExtraAccountingSessions={setShowExtraAccountingSessions}
      />
      {showAccountingSessions && (
        <StaySessionsTable stay={Stay} setIsLoaded={setIsLoaded} />
        // <SessionsTable
        //   accountingSessions={Stay.getAccountingSessions}
        //   setIsLoaded={setIsLoaded}
        //   deleteAccountingSession={deleteAccountingSession}
        // />
      )}
      {showExtraAccountingSessions && (
        <StaySessionsTable stay={Stay} setIsLoaded={setIsLoaded} extra />

        // <SessionsTable
        //   accountingSessions={Stay.getExtraAccountingSessions}
        //   setIsLoaded={setIsLoaded}
        //   deleteAccountingSession={deleteAccountingSession}
        // />
      )}
    </DashboardLayout>
  );
};

export default index;
